<template>

    

    <div class="content-wrap">
      <div class="register-wrap">
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="영업기회ID">
                <template #end="slotProps">
                  <ElInput :id="slotProps.id" v-model="state.salesOptyParams.sales_id" disabled placeholder="자동생성" />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="End User" required>
                <template #end="slotProps">
                  <div class="input-group">
                    <ElInput :id="slotProps.id" v-model="state.salesOptyParams.end_user_cmp_nm" ref="endCmpNmRef" readonly />
                  </div>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="매출처">
                <template #end="slotProps">
                  <div class="input-group">
                    <ElInput :id="slotProps.id" v-model="state.salesOptyParams.sales_cmp_nm" ref="salesCmpNmRef"readonly />
                  </div>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="담당자1" required>
                <template #end="{id}">
                    <ElInput :id="id" v-model="state.salesOptyParams.manager1" ref="manager1Ref"  readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-6">
            <div class="mb-3">
              <ElLabel name="영업기회명" required>
                <template #end="{id}">
                    <ElInput :id="id" v-model="state.salesOptyParams.sales_nm" ref="salesNmRef" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="영업대표" required>
                <template #end="{id}">
                    <ElInput :id="id" v-model="state.salesOptyParams.sales_ceo" ref="salesCeoRef" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="담당자2">
                <template #end="{id}">
                    <ElInput :id="id" v-model="state.salesOptyParams.manager2" ref="manager2Ref"  readonly/>
                </template>
              </ElLabel>
            </div>
          </div>              
        </div>
  
  
        <div class="row">
          <!-- <div class="col-md-3">
            <div class="mb-3" >
              <ElLabel name="제조사">
                <template #end="{id}">
                  <div class="input-group mb-3">
                    <ElInput :id="id" v-model="state.salesOptyParams.maker_cmp_nm" readonly/>
                    <ElButton type="s-search"></ElButton>
                  </div>
                </template>
              </ElLabel>
            </div>
          </div> -->
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="Bridge(B),Risk(R)">
                <template #end>
                  <SelectCode
                  :cd_gr="'BNR_CD'"
                  :isShow="false"
                  :hyphenIS="true"
                  :matchCd="state.salesOptyParams.bnr_cd"
                />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="Stage" required>
                <template #end>
                  <SelectCode
                  :cd_gr="'STG_CD'"
                  :isShow="false"
                  :matchCd="state.salesOptyParams.stage_cd"
                />
                </template>
              </ElLabel>
            </div>
          </div>          
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="우선협상자 선정일(Won Date)" required>
                <template #end>
                  <DatePicker
                    ref = "wonDateRef"
                    :selectDate="state.salesOptyParams.won_dt"
                    :minDate="minDate"
                    disabled
                    />
                </template>
              </ElLabel>
            </div>
          </div>
  
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="PO발행일" required>
                <template #end>
                  <DatePicker
                    ref="poDateRef"
                    :selectDate="state.salesOptyParams.po_dt"
                    :minDate="minDate"
                    disabled
                    />
                </template>
              </ElLabel>
            </div>
          </div>    
        </div>
        
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="최초 등록일">
                <template #end>
                  <DatePicker
                    :selectDate="state.salesOptyParams.reg_dt"
                    @return="r=>state.salesOptyParams.reg_dt = r"
                    disabled
                  />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="고객PO#">
                <template #end="{id}">
                  <ElInput :id="id" classNm="form-control me-1" v-model="state.salesOptyParams.custom_po" onlyNumber :maxlength="19" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="상품(납품)정보">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.salesOptyParams.prd_info" :maxlength="20" readonly/>
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="납품완료일">
                <template #end="{id}">
                  <DatePicker
                    :selectDate="state.salesOptyParams.dlv_dt"
                    @return="r=>state.salesOptyParams.dlv_dt = r"
                    disabled
                  />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="PSP 지정여부">
                <template #end="{id}">
                  <SelectCode
                    :cd_gr="'YN_CD'"
                    :matchCd="state.salesOptyParams.psp_yn"
                    :is-show="false"
                  />
                </template>
              </ElLabel>
  
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="검수완료일">
                <template #end="{id}">
                  <DatePicker
                    :selectDate="state.salesOptyParams.isp_dt"
                    disabled
                  />
                </template>
              </ElLabel>
  
            </div>
          </div>
        </div>
  
        <div class="row">
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="갱신계약 영업기회 매핑">
              </ElLabel>
              <ElInput :id="id" v-model="state.salesOptyParams.w_sales_id" readonly/>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="계약만료일">
              </ElLabel>
              <DatePicker
              :selectDate="state.salesOptyParams.w_end_dt"
              :textable="true"
              disabled
              />
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <!--  활성화 클래스 btn-active -->
              <ElLabel name="즐겨찾기">
                <template #end="{ id }">
                  <ElButton 
                    :id="id"
                    type="bookmarkL"
                    :active="state.salesOptyParams.bkmark_yn === 'Y'"
                    disabled
                  >
                    즐겨찾기 추가
                  </ElButton> 
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="Aging(Days)">
                <template #end="{ id }">
                  <ElInput :id="id" v-model="aginng" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="총 매출금액" required>
                <template #end="{id}">
                    <ElInput
                      :id="id"
                      :modelValue="priceToString(outcome_sum)"
                      @update:modelValue="r=>outcome_sum = r"
                      readonly
                    />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="총 매입금액" required>
                <template #end="{id}">
                    <ElInput
                      :id="id"
                      :modelValue="priceToString(income_sum)"
                      @update:modelValue="r=>income_sum = r"
                      readonly
                    />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="GM Amount" required>
                <template #end="{id}">
                    <ElInput
                      :id="id"
                      :modelValue="priceToString(gm_amt)"
                      @update:modelValue="r=>gm_amt = r"
                      readonly
                    />
                </template>
              </ElLabel>
            </div>
          </div>
          <div class="col-md-3">
            <div class="mb-3">
              <ElLabel name="GM%" required>
                <template #end="{id}">
                    <ElInput
                      :id="id"
                      :modelValue="priceToString(gm_amt_per)"
                      @update:modelValue="r=>gm_amt_per = r"
                      readonly
                    />
                </template>
              </ElLabel>
            </div>
          </div>
        <div class="row">
          <div class="col-md-12">
            <div class="mb-1">
              <ElLabel name="메모">
                <template #end="{id}">
                  <ElInput :id="id" v-model="state.salesOptyParams.memo" readonly/>
                </template>
              </ElLabel>
            </div>
          </div>
        </div> 
    </div>
         
        
        <!--caption-->
        <div class="row">
          <Caption
            ref="captionRef"
            :tbId="'sales'"
            :cap_seq="state.salesOptyParams.opty_seq"
            :readonly="true"
          />
        </div>
  
      </div><!-- //register-wrap -->
  
      <div class="text-end py-3">
        <ElButton type="primary" @buttonClick="routerCmn.goBack()">이전</ElButton>
      </div>
  
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton 
              type="accordionHeader" 
              target="panelsStayOpen-collapseOne"
            >
              매입 매출처 정보
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse">
            <div class="accordion-body accordion-body-register">
              
              <div class="search-wrap">
                <div class="row">
                  <div class="col-md-4">
                    <div class="mb-3">
                      <ElLabel name="매입처">
                        <template #end="{ id }">
                          <ElInput :id="id" v-model="state.searchParam.buy_cmp_info_nm" @inputKeyupEnter="searchInoutList()"/>
                        </template>
                      </ElLabel>
                      
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="mb-3">
                      <ElLabel name="상품">
                        <template #end="{ id }">
                          <ElInput :id="id" v-model="state.searchParam.goods_nm" @inputKeyupEnter="searchInoutList()"/>
                        </template>
                      </ElLabel>
  
                    </div>
                  </div>                      
                </div>
              </div>
              <div class="search-detail-wrap"></div>
    
              <div class="text-end py-2">
                <ElButton type="search" @buttonClick="searchInoutList()">검색</ElButton>
              </div>
    
              <div class="d-flex justify-content-between">
                <div></div>
                <div class="table-btn-group d-flex align-items-center">
                  <ElButton type="excelDownload" @buttonClick="inoutExcelDown()">엑셀다운</ElButton>
                </div>
              </div>
  
              <div class="table-list">
                <DataTable
                  :value="state.searchInoutList"
                  paginator                  
                  :rows="10"
                  :rowsPerPageOptions="[10, 20, 50, 100, 200]"
                  :pt="{
                    wrapper : {style:'height : 600px'},
                    column: {
                        bodycell: ({ state }) => ({
                            class: [{ 'pt-0 pb-0': state['d_editing'] }]
                        })
                    }
                  }"
                >
                <template #empty>
                      <div>데이터가 존재하지 않습니다.</div>
                  </template>
                  <Column>
                    <template #header>
                      <ElCheckbox v-model="allCheck"/>
                    </template>
                    <template #body="{ data }">
                        <ElCheckbox 
                        v-model="state.inoutSelectedRow" 
                        :value="data"
                        />
                    </template>
                  </Column>
                  <Column
                    v-for="inout of state.inoutGridColumn"
                    :key="inout.field"
                    :field="inout.field"
                    :header="inout.header"
                    :style = "inout.style"
                    :sortable ="inout.sortable"
                  >
                  <template #body="{data,field}">
                    <!-- 상품 분류 cell 클릭시 모달 open-->
                    <div v-if="field.includes('class_nm')" >
                      <span>{{ data[field]}}</span>
                    </div>
  
                    <!-- 제조사 cell 클릭시 모달 open-->
                    <div v-else-if="field == 'made_cmp_info_nm'">
                      <span class="elip-div2">{{ getSummaryData(data[field])}}</span>
                    </div>
  
                    <!-- 매입처 cell 클릭시 모달 open-->
                    <div v-else-if="field == 'buy_cmp_info_nm'">
                      <span class="elip-div2">{{ getSummaryData(data[field])}}</span>
                    </div>
                    <!--GM 필드 추가 2024-11-05-->
                    <div v-else-if="field == 'gm_amt'">
                      {{numberFomat(data[field]) }}
                    </div>

                    <div v-else-if="field == 'gm_amt_per'">
                      {{data[field] }}
                    </div> 

                    <!-- 숫자 포멧팅-->
                    <div v-else-if="field.includes('sum')">
                      <span> {{ numberFomat(data[field])}} </span>
                    </div>

                    <div v-else-if="field == 'memo' &&  data.memo !=''" :class="getMemoOptionStyle('Y')" @click="clickOpenDialog({key:'view' , target: state.searchInoutList[data.index].memo,title :'매출세금 계산서 발행여부 취소사유'})">
                      <div>{{ '보기'}}</div>
                    </div>
                    <div v-else-if="field == 'memo' && data.memo ==''" :class="getMemoOptionStyle('N')">
                      <div>{{ '없음' }}</div>
                    </div>
  
                    <!--그 외 cell-->
                    <span v-else>{{ data[field] }}</span>
                  </template>
                  </Column>
                </DataTable>
              </div> 
              
            </div>
          </div>
        </div>
      </div>  
  
      <div class="accordion" id="accordionPanelsStayOpenExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <ElButton type="accordionHeader" target="panelsStayOpen-collapseTwo" :active="state.resFileList.length > 0">
              첨부파일
            </ElButton>
          </h2>
          <div id="panelsStayOpen-collapseTwo" :class="[state.resFileList.length > 0 ?'accordion-collapse show' : 'accordion-collapse collapse']">
            <div class="accordion-body accordion-body-register">
              <FileUpload
                ref="fileUploadRef"
                :canUpdate="false"
                @return="res => getFileList(res)"
                @deleteData="res => getDeleteFile(res)"
              />
            </div>
          </div>
        </div>
      </div>    

      <!-- 영업기회 이력 조회 -->
      <OptyHistoryComponent/>
      <!-- 매입매출 이력 조회 -->
      <InoutHistoryComponent/>

    </div>
      
      
    <ElButton 
    ref="cmpModalBtnRef"
    data-bs-toggle="modal" 
    data-bs-target="#cmpModal" 
    v-show="false"/>
  
    <ElButton 
    ref="prodModalBtnRef"
    data-bs-toggle="modal" 
    data-bs-target="#prodModal" 
    v-show="false"/>
  
  
    <ExcelManage
      v-show="false"
      ref="excelManageRef"
      :headerKeys="state.excelHeaderKey"
      @return="r => getExcelData(r.sheets)"
    />

    <DialogText ref="DialogTextRef" modal dismissableMask="false"
    />
 
  </template>
    
  <script setup>   
  import { reactive,onBeforeMount,ref,watch,computed } from 'vue';
  
  import FileUpload from '@/components/common/FileUpload.vue';
  import DatePicker from '@/components/common/DatePicker.vue'
  import SelectCode from '@/components/common/SelectCode.vue';
  import Caption from '@/components/common/CaptionList.vue';
  import routerCmn from '@/js/vueRouterCmn';
  import DataTable from "primevue/datatable";
  import Column from "primevue/column";
  import ColumnGroup from "primevue/columngroup"
  import Row from "primevue/row"
  import common from "@/js/common";
  import ExcelManage from '@/components/common/MCO_EX_001.vue';
  import { useUserStore } from '@/store/user'
  const userStore = useUserStore()
  import { useCodeStore } from '@/store/code'
  const codeStore = useCodeStore()
  //공통코드 > api 코드
  
  import { useLoading } from '@/composable/Loading.js'
  const { setIsLoading } = useLoading()
  import { salesOptyInoutList, salesOptyInoutListEdit, salesOptySelect} from '@/api/sales';
  import { getProdRevIdList, prodList } from '@/api/prod';
  import { compList } from '@/api/comp';
  
  import { fileList } from '@/api/file';
  import { router } from '@/router';
  import DialogText from '@/components/common/modal/DialogText.vue';
  import OptyHistoryComponent from './components/OptyHistoryComponent.vue';
  import InoutHistoryComponent from './components/InoutHistoryComponent.vue';
  const fileUploadRef = ref()
  const cmpModalBtnRef = ref()
  const salesCmpNmRef = ref();
  const endCmpNmRef = ref();
  const manager1Ref = ref();
  const manager2Ref = ref();
  const salesNmRef = ref();
  const optyModalBtn = ref();
  const prodModalBtnRef = ref();
  const excelManageRef = ref()
  const captionRef = ref()
  const salesCeoRef = ref()
  const wonDateRef = ref();
  const poDateRef = ref();
  const DialogTextRef = ref()
  
  const allCheck = computed({
      get(){
          return state.inoutRowData.length === state.inoutSelectedRow.length;
      },
      set(newValue){
          state.inoutSelectedRow = newValue ? state.inoutRowData.map((item)=>{return item}) : [];
      }
  })
  
const getSummaryData = (item) => {

let summaryData = item.length > 13 ? item.slice(0, 13) + " ..." : item;

return summaryData
}

  const outcome_sum = computed(()=>{
    let outcome_sum = 0
    state.inoutRowData.forEach((item)=>{
      if(item.outcome_sum){
        item.outcome_sum = typeof item.outcome_sum === 'string' ?  item.outcome_sum.replaceAll(',','') : item.outcome_sum
        outcome_sum += Number(item.outcome_sum)
      }
    })
    return isNaN(outcome_sum) ? 0 : outcome_sum
  })
  
  
  const income_sum = computed(()=>{
    let income_sum = 0
    state.inoutRowData.forEach((item)=>{
      if(item.income_sum){
        item.income_sum = typeof item.income_sum === 'string' ?  item.income_sum.replaceAll(',','') : item.income_sum
        income_sum += Number(item.income_sum)
      }
    })
    return isNaN(income_sum) ? 0 : income_sum
  })
  
  const gm_amt = computed(()=>{
    let outcome_sum_val = Number(outcome_sum.value)
    let income_sum_val = Number(income_sum.value)
  
    let gm_amt =  outcome_sum_val - income_sum_val 
    return isNaN(Number(gm_amt)) ? 0 : gm_amt // Number(gm_amt)
  })
  
  const gm_amt_per = computed(()=>{
    let outcome_sum_val = Number(outcome_sum.value)
    let gm_amt_value = Number(gm_amt.value)
  
    let gm_amt_per = (gm_amt_value / outcome_sum_val * 100).toFixed(1)
    return isFinite(Number(gm_amt_per)) ? Number(gm_amt_per): 0 
  })
  
  const minDate = computed(()=>{
    let minDate = ''
    if(state.salesOptyParams.reg_dt) {
      minDate = state.salesOptyParams.reg_dt
    }else{
      minDate = common.dateFormat(new Date())
    }
    return minDate
  })

  const canList = computed(()=>{
    return common.checkAccessAuth('M001M002')
  })


  onBeforeMount(async()=>{
    //상품분류
    
    //상세조회
    let param = history.state;
  
    if(param.opty_seq && param.sales_id){
  
      state.pageType = 'update'
      state.searchOptyParams.opty_seq = param.opty_seq
      state.searchOptyParams.sales_id = param.sales_id
  
      state.salesOptyParams.opty_seq = param.opty_seq
      state.salesOptyParams.sales_id = param.sales_id
     
      await searchOpty()
  
      await getInoutList()
      getGMandGMper();
      searchInoutList();
    }else{
      alert('잘못된 접근입니다.')
      router.back()
    }
  })
  
  //aginng (날짜차이 계산)
  const aginng = computed(()=>{
    let today = new Date();
    let diffDate;
    if(state.salesOptyParams.reg_dt != null){
      diffDate = Math.abs((today - new Date(state.salesOptyParams.reg_dt).getTime()) / (1000 * 60 * 60 * 24));
    }
    return diffDate ? Math.floor(diffDate) : 0 // 밀리세컨 * 초 * 분 * 시 = 일
  })
  
  
  const state = reactive({
    maxRev : '',
    resFileList : [],
    searchOptyParams : {
      opty_seq : null,
      sales_id : null,
      auth_grp_id:''
    },
    saveType : '',
    salesOptyParams :{
      opty_seq : '',
      sales_id : '',                //영업기회id
      sales_cmp_info_seq : '',      //매출처(회사관리번호로 관리)
      sales_cmp_nm : '',            //매출처이름
      end_user_cmp_info_seq : '',             //endUser(회사관리번호로 관리)
      end_user_cmp_nm : '',             //endUser이름
      manager1 : '',                //담당자1
      manager2 : '',                //담당자2
      sales_nm : '',                //영업기회명
      sales_ceo : userStore.user.userNm ? userStore.user.userNm : '',               //영업대표
      employee_id : userStore.user.employeeId ? userStore.user.employeeId : '', 
      maker_cmp_info_seq : '',                //제조사(회사관리번호로 관리)
      maker_cmp_nm : '',                //제조사이름
      stage_cd : '',                //stage(공통코드)
      bnr_cd : '',                  //Bridge&Risk(공통코드)
      tax_dt : '',                 //매출세금계산서 발행일(일자)
      collect_dt : '',              //수금일(일자) 
      tax_yn : '',                  //발행여부
      collect_yn : '',              //수금여부
      reg_dt : '',              //최초 등록일
      won_dt : '',                 //우선협상자 선정일(일자)
      po_dt:'',                     //po발행일
      custom_po : null,               //고객PO
      prd_info : '',                //상품(납품)정보
      dlv_dt : '',                  //납품완료일
      psp_yn : '',                  //PSP지정여부
      isp_dt : '',                  //검수완료일(일자)
      w_sales_id : '',              //Warranty 영업기회 매핑 id
      w_end_dt : '',                //Warranty End Date(일자)
      w_end_ck : '',                //Warranty End Date 체크(1:체크)
      w_alarm_yn : '',
      ngt_date : '',
      bkmark_yn : 'N',               //즐겨찾기
      memo : '',                    //메모
      outcome_sum : 0,              //총매출금액
      income_sum : 0,               //총매입금액
      gm_amt : 0,                  //GM AMT(매출-매입)
      gm_amt_per : 0,               //GM Amt/매출
      tmp_yn : 'N',
      cap_seq : 0,
      tb_id : 'sales',
    
      attachFileVO: {
        file_div_id: "10",
        file_seq: "", //추가 된 파일 seq 전송
        del_file_seq: "", // 삭제해야 할 파일 seq 전송
      },
    },
    //파일 첨부 데이터()
    fileList: [],
    delFileList: [],
    searchParam:{
      buy_cmp_info_nm :'',
      goods_nm:''
    },
    prodCodeLev : 2,
    clickKey : {
      key : '',
      target : '',
      index : null
    }, 
    warMapping : false,
    tax_dt_s : '',
    tax_dt_e : '',
    inoutGridMainCtgy : [
      {header : '제조사', rowspan:2,colspan:1,style:{minWidth : '180px'}},
      {header : '매입처', rowspan:2,colspan:1,style:{minWidth : '180px'}},
      {header : '상품' , rowspan:1,colspan:2,style:{textAlign : 'center', minWidth : '200px'}},

      {header : '매출금액(원)' , rowspan:2,colspan:1,style:{textAlign : 'right',minWidth : '150px'}},
      {header : '매입금액(원)' , rowspan:2,colspan:1,style:{textAlign : 'right',minWidth : '150px'}},

      {header : '매출세금계산서 발행일' , rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '200px'}},
      {header : '발행여부' , rowspan:2,colspan:1,style:{textAlign : 'center', minWidth : '100px'}},
      {header : '수금일' , rowspan:2,colspan:1,style:{textAlign : 'center',minWidth : '180px'}},
      {header : '수금여부' , rowspan:2,colspan:1,style:{textAlign : 'center', minWidth : '100px'}},

      {header : '세금계산서 매입일' , rowspan:2,colspan:1,style:{textAlign : 'center', minWidth : '180px'}},
      {header : '매입여부' , rowspan:2,colspan:1,style:{textAlign : 'center', minWidth : '100px'}},
      {header : '지급일' , rowspan:2,colspan:1,style:{textAlign : 'center', minWidth : '180px'}},
      {header : '지급여부' , rowspan:2,colspan:1,style:{textAlign : 'center', minWidth : '100px'}},
    ],
  
    excelModalColDefs: [
      { header: "제조사", field: "made_cmp_info_nm", req: true, style: { minWidth: '100px' } },
      { header: "매입처", field: "buy_cmp_info_nm", req: true, style: { minWidth: '100px' } },
      { header: "상품", field: "class_nm", req: true, style: { minWidth: '200px' } },
      { header: "매출금액(원)", field: "outcome_sum", style: { minWidth: '150px' } },
      { header: "매입금액(원)", field: "income_sum", req: true, style: { minWidth: '150px' } },
      { header: "매출세금계산서 발행일 (YYYY-MM-DD)", field: "tax_dt", style: { minWidth: '200px' },type:'date' },
      { header: "발행여부", field: "tax_yn", style: { minWidth: '100px' } },
      { header: "수금일(YYYY-MM-DD)", field: "collect_dt", style: { minWidth: '250px' },type:'date' },
      { header: "수금여부", field: "collect_yn", style: { minWidth: '100px' } },
      { header: "세금계산서 매입일(YYYY-MM-DD)", field: "tax_sale_dt", type: 'number', style: { minWidth: '180px' },type:'date' },
      { header: "매입여부", field: "tax_sale_yn", style: { minWidth: '100px' } },
      { header: "지급일(YYYY-MM-DD)", field: "pay_dt", style: { minWidth: '180px' },type:'date' },
      { header: "지급여부", field: "pay_yn", style: { minWidth: '100px' } },
    ],
  
    inoutGridSubCtgy : [
      {header : '1단계', field : 'class_nm1'},
      {header : '2단계', field : 'class_nm2'},
    ],
    inoutGridColumn: [
      { header: "매입매출 그룹", field: "group", style: { textAlign: "center", minWidth: "120px" }, sortable: true },
      { header: "제조사",field : 'made_cmp_info_nm', style: {minWidth:'120px'}, sortable:true},
      { header: "매입처",field : 'buy_cmp_info_nm', style: {minWidth:'120px'}, sortable:true},
      { header: "상품1단계", field: 'class_nm1', style: { minWidth: '100px' }, sortable: true },
      { header: "상품2단계", field: 'class_nm2', style: { minWidth: '100px' }, sortable: true },
      { header: "상품3단계", field: 'class_nm3', style: { minWidth: '100px' }, sortable: true },
      { header: "매출금액(원)", field : 'outcome_sum', style: {textAlign : 'right', minWidth:'120px'}, sortable:true},
      { header: "매입금액(원)",field : 'income_sum', style: {textAlign : 'right', minWidth:'120px'}, sortable:true},
      { header: "Gross Margin",field : 'gm_amt', style: {textAlign : 'right', minWidth:'140px'}, sortable:true},
      { header: "GM(%)",field : 'gm_amt_per', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},
      { header: "매출세금계산서 발행일", field : 'tax_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true},
      { header: "발행여부",field : 'tax_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},
      { header: "수금일", field : 'collect_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true},
      { header: "수금여부", field : 'collect_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},

      { header: "매입세금계산서 발행일", field : 'tax_sale_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true},
      { header: "매입여부", field : 'tax_sale_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},
      { header: "지급일",field : 'pay_dt', style: {textAlign : 'center', minWidth:'140px'}, sortable:true},
      { header: "지급여부", field : 'pay_yn', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},
      { header: "취소사유", field : 'memo', style: {textAlign : 'center', minWidth:'70px'}, sortable:true},
        
    ],
    inoutRowData : [],
    inoutSelectedRow : [],
    searchInoutList : [],
    successCnt : 0,
    recentProdRev : '',
    pageType : 'insert',
    typeName : '',
    excelHeaderKey : [
      'made_cmp_info',
      'buy_cmp_info',
      'class_id',
      'outcome_sum',
      'income_sum',
      'tax_dt',
      'tax_yn',
      'collect_dt',
      'collect_yn',
      'tax_sale_dt',
      'tax_sale_yn',
      'pay_dt',
      'pay_yn',
    ],
    optyInoutGroupList : [],
    groupName : '',
  
  })
  
// watch(
//   () => state.inoutRowData.length,(newVal,oldVal)=>{
//     searchInoutList()
//   },
// )

watch(
  () => state.searchParam.buy_cmp_info_nm,(newVal,oldVal)=>{
    searchInoutList()
  },
)

watch(
  () => state.searchParam.goods_nm,(newVal,oldVal)=>{
    searchInoutList()
  },
)

const clickOpenDialog = (value) =>{
  const {key,target,title} = value
  DialogTextRef.value.openDialog(key,target,title)
}

const getMemoOptionStyle = (item) => {
  const stageValue = item
  let classNm = ''
  if (stageValue == 'Y') {
    classNm = 'stage stage-close';
  } else if (stageValue == 'N') {
    classNm = 'stage stage-omit';
  }
  return classNm
}


//매입매출정보 조회
const getInoutList = async()=>{
  try{
    setIsLoading(true)
    //상품 조회 코드 추가하기
    const revRes = await getProdRevIdList()
    revRes.rtn.forEach((item)=>{
      if(item.rev_id > state.maxRev) state.maxRev = item.rev_id
    })
    const prodRes = await prodList({rev_id : state.maxRev})
    const prodResList = [...prodRes.rtn]

    let searchParams = {
      opty_seq:state.searchOptyParams.opty_seq,
      sales_id : state.searchOptyParams.sales_id,
      buy_cmp_info_nm : state.searchParam.buy_cmp_info_nm
    }

    const res = await salesOptyInoutList(searchParams)
    let resList = [...res.rtn]
    state.inoutRowData = resList.map((item,index)=>{
      item.index = index

      Object.keys(item).forEach((key)=>{
        if(key.includes('_dt')){
          if(item[key] !== '19000101'){
            item[key] = item[key] || 'N/A'
          }else{
            item[key] = 'N/A'
          }
        }

        if(key.includes('_yn') && item[key] === 'A'){
          item[key] = 'N/A'
        }

        if (key == 'opty_inout_seq') {
            item['group'] = setGroupName(item, key)
        }
      })

      
      let codeFam = common.findUperCode(item.prod_class_id,prodResList) || []
      item.prod_level = codeFam.length
      let flag = true

      if(state.searchParam.goods_nm){
        codeFam.forEach((codeItem)=>{
          let codeNm = codeItem.class_nm.toLowerCase()
          if(!codeNm.includes(state.searchParam.goods_nm.toLowerCase())){
            flag = false
          }
        })
      }

      if(flag) {
        codeFam.forEach((codeItem,index)=>{
          item[`class_nm${index+1}`] = codeItem.class_nm
        })
        //createInoutCol(codeFam)
        return item
      }

    })
    
  } catch(err) {
    console.error(err)
  } finally {
    setIsLoading(false)
  }
}
  
  //북마크 체크시 실행 함수
  const changeBkmark =()=>{
    if(state.salesOptyParams.bkmark_yn === 'Y'){
      state.salesOptyParams.bkmark_yn = 'N'
    }else{
      state.salesOptyParams.bkmark_yn = 'Y'
    }
  }
  

  
  const getDeleteFile = (res) =>{
    state.delFileList.push(res.file_seq);
  }
  
  
  const moveToPage = (url)=>{
    routerCmn.routerPush(url)
  }
  
  //모달 선택버튼으로 닫혔을 경우 선택값 update
  //회사,영업기회,상품분류 모달
  const updateParam = (type,returnData) =>{
    let name = '';
  
    if(returnData.cmp_dvsn_nm != '') {
      name = `${returnData.cmp_nm}(${returnData.cmp_dvsn_nm})`
    } else {
      name = `${returnData.cmp_nm}`
    }
  
    if(type == 'company'){
      //매출처,end_user,제조사 매핑
      if(!returnData)  return
  
      if(state.clickKey.target === 'sales'){
        state['salesOptyParams'][`${state.clickKey.key}_nm`] = name
        state.salesOptyParams[`${state.clickKey.key}_info_seq`] = returnData.cmp_info_seq
      }
      //매입매출처 정보 > 제조사,매입처 매핑
      else if(state.clickKey.target === 'inout'){
        state.inoutRowData[state.clickKey.index][`${state.clickKey.key}_cmp_info_nm`] = name // `${returnData.cmp_nm}(${returnData.cmp_dvsn_nm})`
        state.inoutRowData[state.clickKey.index][`${state.clickKey.key}_cmp_info_seq`] = returnData.cmp_info_seq
      }
      
      state.clickKey = {key : '',target : ''}
  
    }else if(type == 'opty'){
      state.salesOptyParams.w_sales_id = returnData.sales_id
    }else if(type == 'prod'){
      if(returnData){
          
        if(returnData.codeFam.length>0){
          state.inoutRowData[state.clickKey.index]['prod_rev_id'] = returnData.rev_id
          returnData.codeFam.forEach((item,index)=>{
            state.inoutRowData[state.clickKey.index][`class_nm${index+1}`] = item['class_nm']
          })
        }
        
        //현재 보여지는 단계보다 높을경우 inout 그리드 상품 단계 컬럼 추가
        createInoutCol(returnData.codeFam)
  
        state.inoutRowData[state.clickKey.index].prod_class_id = returnData.selectKey
      }
      
    }
   
  }
  
  const createInoutCol = (codeFam)=>{
    if(state.prodCodeLev <  codeFam.length){
        for(var i=(state.prodCodeLev+1); i<=codeFam.length; i++){
          //현재 상품 뎁스 2단계 초과된 상품코드 등록 시 그리드 컬럼에 새로운 단계 컬럼 추가
          let col = {header: `${i}단계` , field: `class_nm${i}`,style:{minWidth:'150px'}}
  
          //상단 헤더 컬럼(colspan 늘려야함)
          state.inoutGridMainCtgy.map((item)=>{
            if(item.header == '상품'){
              item.colspan = i
            }
            return item
          })
  
          state.inoutGridColumn.map((item2,index)=>{
            if(item2.field == `class_nm${i-1}`){
              let SubCtgy = {field : `class_nm${i}`}
              state.inoutGridColumn.splice(index+1, 0, SubCtgy);
            }
            return item2
          })
  
          //하단 헤더 컬럼
          state.inoutGridSubCtgy.splice(i-1, 0, col);
          
        }
        state.prodCodeLev = codeFam.length
  
    }
  }
  
  
  //매입매출 정보 저장
  const saveInout = async(editInoutList)=>{
    if(!editInoutList)routerCmn.routerPush('/sr/MSR_SO_002')
  
    for(let param of editInoutList){
      state.excelHeaderKey.forEach((key)=>{
        if(key.includes('_dt') || key.includes('_yn')){
          if(param[key] === 'N/A' || !param[key])param[key] = ''
        }
      })
      param.sales_id = state.salesOptyParams.sales_id
      param.opty_seq = state.salesOptyParams.opty_seq
      param.opty_inout_seq = param.opty_inout_seq || ''
      param.tax_sale_dt = param.tax_sale_dt.replaceAll(/-|NaN/gi,'')
      param.pay_dt = param.pay_dt.replaceAll(/-|NaN/gi,'')
      param.tax_dt = param.tax_dt.replaceAll(/-|NaN/gi,'')
      param.collect_dt = param.collect_dt.replaceAll(/-|NaN/gi,'')
    }
  
    let params = {
      salesOptyInoutListVO : editInoutList
    }
    try {
      setIsLoading(true)
      const res = await salesOptyInoutListEdit(params)
      routerCmn.routerPush('/sr/MSR_SO_002')
    } catch (err) {
      console.error(err)
    } finally {
      setIsLoading(false)
    }
  }
  
  
  const priceToString = (item) => {
      return common.checkNumberComma(item)
  }
  
  //상세조회
  const searchOpty = async() =>{
    try {
      setIsLoading(true)

      
      if(userStore.user.authGrpId !== ('ADMIN'&& 'C') && canList){
          state.searchOptyParams.auth_grp_id  = 'ADMIN'
      }

      const res = await salesOptySelect(state.searchOptyParams)

      if(Object.keys(res.rtn).length === 0){
        alert('조회되는 영업기회가 없습니다.확인 후 다시 조회해주세요.')
        router.push('/sr/MSR_SO_002')
        return
      }

      Object.assign(state.salesOptyParams, res.rtn);
      if(state.salesOptyParams.custom_po == '' || state.salesOptyParams.custom_po == undefined ){
        state.salesOptyParams.custom_po = null
      }
  
      if(state.salesOptyParams.w_end_ck ==  '1'){
        state.salesOptyParams.w_end_ck = true
      }
      //str to date (날짜 포멧)
      state.salesOptyParams.tax_dt =    res.rtn.tax_dt ? common.dateFormat(new Date(res.rtn.tax_dt.replaceAll('KST','')))  : ''
      state.salesOptyParams.collect_dt = res.rtn.collect_dt ? common.dateFormat(new Date(res.rtn.collect_dt.replaceAll('KST',''))) : ''
      state.salesOptyParams.reg_dt = res.rtn.reg_dt ? common.dateFormat(new Date(res.rtn.fmt_reg_dt.replaceAll('KST',''))) : ''
      state.salesOptyParams.won_dt = res.rtn.won_dt ? common.dateFormat(new Date(res.rtn.won_dt.replaceAll('KST',''))) : ''
      state.salesOptyParams.dlv_dt = res.rtn.dlv_dt ? common.dateFormat(new Date(res.rtn.dlv_dt.replaceAll('KST',''))) : ''
      state.salesOptyParams.isp_dt = res.rtn.isp_dt ? common.dateFormat(new Date(res.rtn.isp_dt.replaceAll('KST',''))) : ''
      state.salesOptyParams.w_end_dt = res.rtn.w_end_dt ? common.dateFormat(new Date(res.rtn.w_end_dt.replaceAll('KST',''))) : ''
      state.salesOptyParams.po_dt = res.rtn.po_dt ? common.dateFormat(new Date(res.rtn.po_dt.replaceAll('KST',''))) : ''
  
      if(state.salesOptyParams.w_sales_id) state.warMapping = true
  
      //첨부파일이 존재할경우 파일리스트 조회api 호출
      if (res.rtn.file_seq_grp != "" && res.rtn.file_seq_grp != null && res.rtn.file_seq_grp != undefined) {
        let apiParam = {
          file_seq_grp: res.rtn.file_seq_grp,
        };

      
        try {
          const resFileList = await fileList(apiParam)
          fileUploadRef.value.state.fileParams.fileListVo = resFileList.rtn
          state.resFileList = resFileList.rtn
        } catch (err) {
          console.log("파일리스트 조회 api 에러", error);
          alert("파일리스트 조회에 실패했습니다.");
          throw err
        }
      }
    } catch (err) {
      console.error(err)
      routerCmn.routerPush("/sr/MSR_SO_002");
    } finally {
      setIsLoading(false)
    }
  }

  //매입매출 목록 다운로드
  const inoutExcelDown = ()=>{
    let fileNm = '매입매출 목록'
    let inoutList = state.inoutRowData;
    let header = [
      {header : '매입매출 그룹', key:'group'},
      {header : '제조사',key:'made_cmp_info_nm'},
      {header : '매입처',key:'buy_cmp_info_nm'},
      {header : '상품 1단계' ,  key : 'class_nm1'},
      {header : '상품 2단계' ,  key : 'class_nm2'},
      {header : '상품 3단계' ,  key : 'class_nm3'},
      {header : '매출금액(원)' ,key:'outcome_sum'},
      {header : '매입금액(원)' , key:'income_sum'},

      {header : 'Gross Margin' , key:'gm_amt'},
      {header : 'GM(%)' , key:'gm_amt_per'},
      {header : '매출세금계산서 발행일 (YYYY/MM/DD)',key:'tax_dt'},
      {header : '발행여부',key:'tax_yn' },
      {header : '수금일 (YYYY/MM/DD)' ,key:'collect_dt'},
      {header : '수금여부' ,key:'collect_yn'},

      {header : '매입세금계산서 발행일' ,key:'tax_sale_dt'},
      {header : '매입여부' ,key:'tax_sale_yn'},
      {header : '지급일' ,key:'pay_dt'},
      {header : '지급여부' ,key:'pay_yn'},
      {header : '취소사유' ,key:'memo'}
    ];
    let headerProps = state.inoutGridColumn.map((item)=>{
      return item.field
    })
    excelManageRef.value.excelDownload(fileNm,header,inoutList,headerProps)
  }

  //get upload File
  const getExcelData = async(excelData) =>{
    let index = state.inoutRowData.length
    let offset = 9*60*60 * 1000;
  
    const cmpRes = await searchCmpList({page_count : 1,unit_count : 999999})
    const cmpList = [...cmpRes.rtn]
  
    const prodRes = await searchProdList()
    const prodList = [...prodRes.rtn]
    excelData[0].forEach((item)=>{
      item.index = index 
      Object.keys(item).forEach((key)=>{
        //엑셀 날짜 데이터들은 utc 기준이라 kst시간대로 +9시간 맞추기
        if(item[key] instanceof Date){
          item[key] = common.dateFormat(new Date(item[key].getTime() + offset))
        }
  
        //회사관리번호 매핑해서 이름으로 보여주기
        if(key === 'made_cmp_info' || key === 'buy_cmp_info'){
          let cmp = cmpList.find((cmp)=>cmp.cmp_info_seq === item[key])
  
          if(cmp){
            let cmp_nm = cmp['cmp_nm']
            item[`${key}_seq`] = item[key]
            item[`${key}_nm`] = cmp_nm
          }else{
            item[`${key}_seq`] = '' 
            if(!item.incorrectCol) item.incorrectCol = true
          }
        }
  
        //상품코드를 상품명으로 보여주기
        if(key === 'class_id'){
          let prodFam = common.findUperCode(item[key],prodList)
          if(prodFam.length > 0){
            item['prod_class_id'] = item[key]
            item['prod_rev_id'] = state.maxRev
            item['prod_level'] = prodFam.length
            //createInoutCol(prodFam)
            prodFam.forEach((prod,index)=>{
              item[`class_nm${index+1}`] = prod.class_nm
            })
          }else{
            // if(!item.incorrectCol) item.incorrectCol = true
          }
  
        }
        
        if(key === 'tax_yn' || key === 'collect_yn' ||key === 'tax_sale_yn' ||key === 'pay_yn'){
          item[key] = item[key] ? item[key].toUpperCase() : item[key]
        }
  
      })
  
  
      state.inoutRowData.push(item)
      index += 1
    })
  
    alert('영업기회 저장 후에 반영 데이터이며 저장하지 않을 경우 등록하신 매입매출은 저장되지 않습니다.')
  
  }
  
  function numberFomat(number){
    if(number){
      return number = common.checkNumberComma(number)
    }
    return number
  }
  
  async function searchCmpList(params){
    try{
      setIsLoading(true)
      const res = await compList(params)
      return res
    }catch(e){
      console.log(e)
    }finally{
      setIsLoading(false)
    }
  }
  
  async function searchProdList(params){
    try{
      setIsLoading(true)
      const revRes = await getProdRevIdList()
      revRes.rtn.forEach((item)=>{
        if(item.rev_id > state.maxRev) state.maxRev = item.rev_id
      })
      const prodRes = await prodList({rev_id : state.maxRev})
  
      return prodRes
    }catch(e){
      console.log(e)
    }finally{
      setIsLoading(false)
    }
  }
  

//매입매출정보 조회
async function searchInoutList(){
  let searchList = [...state.inoutRowData]

  //매입매출 원본 리스트에서 매입처, 상품이름 검색 filter 로직
  searchList = state.inoutRowData.filter((item)=>{
    let flag = true
    
    //매입처 이름 조건 filter
    if(state.searchParam.buy_cmp_info_nm){
      flag = item.buy_cmp_info_nm ? item.buy_cmp_info_nm.includes(state.searchParam.buy_cmp_info_nm) : false
      //flag false면 아래로직까지 가지말고 거르기
      if(!flag) return
    }

    //상품 이름 검색 (뎁스가 어디까지 늘어날지몰라 모든 뎁스 유사어 있으면 검색리스트 추가)
    if(state.searchParam.goods_nm){
      //검색어가 있고 prod_level이 없는 경우 검색 제외
      //prod_level은 일괄등록, 매입매출 상품 적용할때(updateParam 함수 참조) 추가됨
      if(item.prod_level){
        for(var i=1; i<=item.prod_level; i++){
          let classNm = item[`class_nm${i}`].toLowerCase()
          flag = classNm ? classNm.includes(state.searchParam.goods_nm.toLowerCase()) : false
          if(flag) break;
        }
      }else{
          flag = false
      }
    }


    if(flag){
      return item
    }
  })

  state.searchInoutList = searchList || []
  
}

const getGMandGMper = (list) => {

  let inoutRowDataList = state.inoutRowData
  inoutRowDataList.map((item,index) =>{
    
    let a = Number(item.income_sum)
    let b = Number(item.outcome_sum)

    item['gm_amt'] = b - a
    const gm_amt_per = item['gm_amt'] / Number(item['outcome_sum']) * 100
    item['gm_amt_per']= `${Math.round(isFinite(Number(gm_amt_per)) ? Number(gm_amt_per): 0 )}%`
  })
  state.inoutRowData = inoutRowDataList
}

const setGroupName = (item, key) => {
    if (state.optyInoutGroupList && Object.keys(state.optyInoutGroupList).length === 0) {
      state.groupName = 'A'      
    }else{
      state.groupName = incrementGroupName(state.groupName)
    }

    state.optyInoutGroupList.push({
        seq: item[key],
        value: state.groupName,
    });
    return state.groupName
};

const incrementGroupName = (groupName) => {
    // Z까지 도달하면 길이를 증가시키는 로직
    const isAllZ = groupName.split('').every(char => char === 'Z')
    if (isAllZ) {
        return 'A'.repeat(groupName.length + 1)
    }

    // 뒤에서부터 알파벳을 증가시키는 로직
    const chars = groupName.split('')
    for (let i = chars.length - 1; i >= 0; i--) {
        if (chars[i] === 'Z') {
            chars[i] = 'A'
        } else {
            chars[i] = String.fromCharCode(chars[i].charCodeAt(0) + 1)
            break
        }
    }
    return chars.join('');
};

</script>
      
  
  <style scoped>
  .class-nm{
    display:inline-block;
    height: 20px; 
    width:100px;
    cursor: pointer;
  }
  </style>